interface Urls {
  SEND_OTP: string;
  VALIDATE_OTP: string;
  REFRESH_TOKEN: string;
  GET_PROFILE: string;
  GET_WSM_SLOTS: string;
  RESERVATION_CHECK_IN: string;
  GET_EXCLUSIVE_SLOT: string;
  GET_RESERVATIONS: (reservationId: string) => string;
}

export const getUrls = (): Urls => {
  const SERVICE_URL = process.env.REACT_APP_API_URL;
  return {
    SEND_OTP: `${SERVICE_URL}/auth/send-otp`,
    VALIDATE_OTP: `${SERVICE_URL}/auth/validate-otp`,
    REFRESH_TOKEN: `${SERVICE_URL}/auth/refresh`,
    GET_PROFILE: `${SERVICE_URL}/user`,
    GET_WSM_SLOTS: `${SERVICE_URL}/service-slots/admin`,
    RESERVATION_CHECK_IN: `${SERVICE_URL}/reservations/check-in`,
    GET_EXCLUSIVE_SLOT: `${SERVICE_URL}/service-slots/admin/exclusive`,
    GET_RESERVATIONS: (slotId: string) =>
      `${SERVICE_URL}/reservations/admin/${slotId}`,
  };
};
